import React from 'react';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { TAG_LIST_SORT_OPTION_MODEL } from '../../../../store/modules/tag/models';
import TagList from '../TagList';
import TagListSearchBox from '../TagListSearchBox';

const TagListWrap = (props) => {
  const { tagList, tagGroupSelectList, setData, getList, getRelatedTagList, getTagListExcelDownload } = props;

  return (
    <div className="tag-list-wrap">
      {/* 태그 검색 박스*/}
      <TagListSearchBox
        setData={(data) =>
          setData({
            path: ['tagList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        tagGroupSelectList={tagGroupSelectList}
        searchData={tagList.searchData}
        getList={getList}
      />

      {/* 태그 리스트*/}
      <TagList
        tagList={tagList.list}
        initialOption={{
          sortOption: TAG_LIST_SORT_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        }}
        sortOption={tagList.sortOption}
        pagination={tagList.pagination}
        getList={getList}
        getRelatedTagList={getRelatedTagList}
        getTagListExcelDownload={getTagListExcelDownload}
      />
    </div>
  );
};

export default TagListWrap;
